import { Box } from "@mui/material";

import { dayjs } from "@thalamos/common";
import type { SingleUseActionTokenUnbranded } from "@thalamos/aspire-common";
import { SINGLE_USE_ACTION_TOKEN_MAX_AGE_MONTHS } from "@thalamos/aspire-common";

import { Banner, BannerList } from "~/components/design-system/index.js";

export function TokenExpired({
  singleUseActionToken,
}: {
  singleUseActionToken: SingleUseActionTokenUnbranded;
}) {
  const expiryDate = dayjs(singleUseActionToken.created)
    .add(SINGLE_USE_ACTION_TOKEN_MAX_AGE_MONTHS, "month")
    .format("YYYY-MM-DD");

  return (
    <Box data-testid="token-expired">
      <Banner
        title={`Token has expired (was valid until 
          ${expiryDate}). 
        Please contact the Thalamos programme team to issue a new one`}
        bannerType={BannerList.ERROR}
      />
    </Box>
  );
}
